'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _template = require('./template.html');

var _template2 = _interopRequireDefault(_template);

var _controller = require('./controller');

var _controller2 = _interopRequireDefault(_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  restrict: 'E',
  bindings: {},
  template: _template2.default,
  controller: _controller2.default

  // WEBPACK FOOTER //

};


/** WEBPACK FOOTER **
 ** ./client/app/modules/product-page/components/category_listing/index.js
 **/